import { RegexConstants } from '../constants.js'

export const phone = (value) => {
  if (!value || value === '') {
    return true
  }

  value = value.includes('+1') ? value.replace('+1', '') : value

  const result = new RegExp(RegexConstants.phoneNumberTest).test(value)
  return result
}
